// import { MWebContainer } from "./MWebContainer";
import { useMWeb } from "./useMWeb";
import { LoadingWrapper } from "../common/LoadingWrapper";
// import BrandLoader from "../common/loaders/Spinner/BrandLoader";
import { Dataset } from "../api/Datasets";
// import { useContext } from "react";
// import { SessionContext } from "../common/contexts/SessionContext";
import BrandLoader from "../common/loaders/Spinner/BrandLoader";
import { MWebContainer } from "./MWebContainer";
import { useContext } from "react";
import { SessionContext } from "../common/contexts/SessionContext";
import { Container } from "../common/panels/Container/Container";
import { LucideIcon } from "../common/icon/LucideIcon";
import styles from "../Dataset/tiles/Files/Files.module.css";
import { DatasetContext } from "../Dataset/Dataset";
import { getIndexRoute } from "../main/Routing";
// import { toUppercase } from "../common/helperfunctions/stringFunctions";
// import { Link } from "react-router-dom";

interface DatasetDetailMwebProps {
  dataset: Dataset;
  onFullScreenToggle?: () => void;
  permissions: Dataset["permissions"];
  viewShared: boolean;
}
export const DatasetDetailMweb = ({ dataset, onFullScreenToggle, permissions, viewShared }: DatasetDetailMwebProps) => {
  const {
    datasetId,
    MNovaFile,
    MWebFetchFunc,
    MWebFileSaveFunc,
    MWebloadingFunc,
    MWebFinishedCallback,
    MWebErrorCallback,
    MWebFinished,
    MWebLoadingStatus,
    MWebError,
    error,
    fetchStatus,
    status,
    license,
  } = useMWeb({ datasetId: dataset.id });

  const { group, route } = useContext(SessionContext);
  const context = useContext(DatasetContext);

  if (!!context?.viewViewer)
    return (
      <Container
        title={
          <div className="flex row-nowrap align-center gap-5">
            <a className="navbar-brand" href={route(getIndexRoute("dashboard"))} style={{ padding: 0, height: 50 }}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/logos/Logs-Main.svg`}
                className="brand"
                alt="LOGS"
                style={{
                  width: "110px",
                  height: "100%",
                }}
              />
            </a>
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                lineHeight: "24px",
                whiteSpace: "nowrap",
                margin: 0,
                color: "#2b4865",
              }}
            >
              - MWeb
            </h3>
            {/* <Link
              to={route(getIndexRoute(datasetsConstants.frontendIndexRoute))}
              style={{ textDecoration: "none" }}
              title={`Show ${datasetsConstants.entityPlural} table`}
            >
              <div
                className="flex row-nowrap align-center gap-5"
                style={{
                  fontSize: "24px",
                  fontWeight: 600,
                  lineHeight: "24px",
                  whiteSpace: "nowrap",
                }}
              >
                <LucideIcon name={datasetsConstants.icon} color={"var(--primary)"} style={{ width: 20, height: 20 }} />
                {`${toUppercase(datasetsConstants.entityPlural)}`}
              </div>
            </Link> */}
            <div>
              <LucideIcon name="arrow-right" color="var(--gray-400)" />
            </div>

            <span
              onClick={onFullScreenToggle}
              style={{
                fontSize: "24px",
                lineHeight: "28px",
                margin: 0,
                fontWeight: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: "pointer",
              }}
            >
              {dataset.name}
            </span>
          </div>
        }
        controls={
          <div className={styles.container_controls}>
            <div
              className={styles.container_controls_fullscreen}
              onClick={onFullScreenToggle}
              title="Toggle fullscreen"
            >
              <LucideIcon name="maximize" />
            </div>
          </div>
        }
        headerStyle={{ height: 56, padding: "5px 10px" }}
        style={{ padding: 0 }}
        containerStyle={{
          position: "fixed",
          width: "100vw",
          height: "100vh",
          top: 0,
          left: 0,
          backgroundColor: "white",
          zIndex: 99999,
          padding: 0,
        }}
      >
        <LoadingWrapper status={status} fetchStatus={fetchStatus} error={error}>
          {MNovaFile ? (
            <MWebContainer
              datasetId={datasetId}
              mNovaFile={MNovaFile}
              MWebFinished={MWebFinished}
              MWebLoadingStatus={MWebLoadingStatus}
              MWebError={MWebError}
              MWebFetchFunc={MWebFetchFunc}
              MWebFileSaveFunc={MWebFileSaveFunc}
              mwebResourcePath={`${globalThis.app.proxy}/${group}/api/0.1/mweb`}
              //mwebResourcePath="/mweb"
              style={{ width: "100%", height: "100%" }}
              MWebloadingFunc={MWebloadingFunc}
              MWebFinishedCallback={MWebFinishedCallback}
              MWebErrorCallback={MWebErrorCallback}
              license={license!}
              permissions={permissions}
              viewShared={viewShared}
            />
          ) : (
            <BrandLoader />
          )}
        </LoadingWrapper>
      </Container>
    );

  return (
    <Container
      title={"MWeb"}
      controls={
        <div className={styles.container_controls}>
          <div className={styles.container_controls_fullscreen} onClick={onFullScreenToggle} title="Toggle fullscreen">
            <LucideIcon name="maximize" />
          </div>
        </div>
      }
      style={{ padding: 0 }}
    >
      <LoadingWrapper status={status} fetchStatus={fetchStatus} error={error}>
        {MNovaFile ? (
          <MWebContainer
            datasetId={datasetId}
            mNovaFile={MNovaFile}
            MWebFinished={MWebFinished}
            MWebLoadingStatus={MWebLoadingStatus}
            MWebError={MWebError}
            MWebFetchFunc={MWebFetchFunc}
            MWebFileSaveFunc={MWebFileSaveFunc}
            mwebResourcePath={`${globalThis.app.proxy}/${group}/api/0.1/mweb`}
            //mwebResourcePath="/mweb"
            style={{ width: "100%", height: "100%" }}
            MWebloadingFunc={MWebloadingFunc}
            MWebFinishedCallback={MWebFinishedCallback}
            MWebErrorCallback={MWebErrorCallback}
            license={license!}
            permissions={permissions}
            viewShared={viewShared}
          />
        ) : (
          <BrandLoader />
        )}
      </LoadingWrapper>
    </Container>
  );
};
